// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_atlas_ziele_plus_landuse: MapboxStyleLayer[] = [
  {
    filter: ['has', 'landuse'],
    type: 'fill',
    id: 'tarmac-landuse-test-datensatz-0r36t3',
    paint: {
      'fill-color': [
        'case',
        ['match', ['get', 'landuse'], ['residential'], true, false],
        '#fdd4c4',
        ['match', ['get', 'landuse'], ['residential'], false, true],
        '#cec0fb',
        'rgba(255, 255, 255, 0.57)',
      ],
    },
  },
]
